import { render, staticRenderFns } from "./Paso2.vue?vue&type=template&id=6ee553ec&scoped=true"
import script from "./Paso2.vue?vue&type=script&lang=js"
export * from "./Paso2.vue?vue&type=script&lang=js"
import style0 from "./Paso2.vue?vue&type=style&index=0&id=6ee553ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee553ec",
  null
  
)

export default component.exports